// Legal documents everyone agrees to before Brill opens.
//
// Bump TERMS_VERSION whenever the terms or the privacy policy change in a way
// people should re-agree to. Everyone is then asked again on their next visit —
// the version each person agreed to is stored on their Clerk account as
// publicMetadata.termsVersion, alongside publicMetadata.termsAcceptedAt.
//
// Use a date you'll recognise later. Nothing parses it; it's only compared.

export const TERMS_VERSION = "2026-08-02";

export const TERMS_URL = "https://www.tevrawood.com/terms-and-conditions";
export const PRIVACY_URL = "https://www.tevrawood.com/privacy-policy";
